import * as React from 'react';
import {Pdf} from "../pdf";
import {
    FoundationsReportBottomContent,
    FoundationsReportLeftAndRightPair, FoundationsReportTeamContent,
    FoundationsReportTopContent,
    PVAStyle,
    PVAStyleBreakdown
} from '../reports';
import {BaseRouteProps} from '../../interfaces';
import {SurveyVersion, Style, StyleText} from '../../models';
import {PVAPage, PVATab} from '..';
// import '../reports/myreport/FoundationsReport.css';
// import '../common/custom-content.css';

interface PdfStyleProps extends BaseRouteProps<{}> {
    userName: string;
    date: string;
    organization: string;
    selectedUserData: {
        name: string;
        style: Style & {
            brief: string;
            content: string;
            core: string;
        };
    };
    surveyVersion: SurveyVersion | null;
    allStyles: Style[];
}

export class PdfStyle extends React.Component<PdfStyleProps> {
    public render() {
        const currentStyle = this.props.selectedUserData.style;
        const badgeColor = currentStyle ? `var(--pva-${currentStyle.name.toLowerCase()})` : 'var(--blue)';
        const currentStyleName = currentStyle ? currentStyle.name.toLowerCase() : '';
        const checkmarkUrl = currentStyleName ? `url("/images/checkmark-${currentStyleName}.svg")` : 'url("/images/checkmark.svg")';
        const checkMarkRedUrl = currentStyleName ? `url("/images/check-mark-${currentStyleName}.svg")` : 'url("/images/check mark red.svg")';
        
        const styleTexts = currentStyle && currentStyle.styleTexts || [];
        const sortedAdditionalStyles:any = styleTexts.filter((styleText: StyleText) => {
            return styleText.styleTextType === 'additional';
        }).sort((one: StyleText, two: StyleText) => {
            if (one.sort > two.sort) {
                return 1;
            } else if (one.sort < two.sort) {
                return -1;
            }
            return 0;
        });
        
        let page = 1;
        let maxPage = 8;
        
        return (
            <Pdf fontSize="8.5px">
                <Pdf.Page>
                    <PVAStyle 
                        notificationService={this.props.notificationService}
                        history={this.props.history}
                        location={this.props.location}
                        match={this.props.match}
                        style={this.props.selectedUserData.style}
                        brief={this.props.selectedUserData.style.brief}
                        content={this.props.selectedUserData.style.content}
                        core={this.props.selectedUserData.style.core}
                        name={this.props.selectedUserData.name}
                        surveyVersion={this.props.surveyVersion}
                        allStyles={this.props.allStyles}
                        selectedUserData={this.props.selectedUserData}
                        hideDichotomies={true}
                        hideButtons={true}
                        showTraits={true}
                    />
                    
                    <FoundationsReportTopContent style={this.props.selectedUserData.style} />
                    <FoundationsReportLeftAndRightPair style={this.props.selectedUserData.style} badgeColor={badgeColor} />
                    <FoundationsReportBottomContent style={this.props.selectedUserData.style} />

                    <Pdf.Footer currentPage={page++} totalPages={maxPage} />
                </Pdf.Page>
                <Pdf.Page>
                    <PVAStyle
                        notificationService={this.props.notificationService}
                        history={this.props.history}
                        location={this.props.location}
                        match={this.props.match}
                        style={this.props.selectedUserData.style}
                        brief={this.props.selectedUserData.style.brief}
                        content={this.props.selectedUserData.style.content}
                        core={this.props.selectedUserData.style.core}
                        name={this.props.selectedUserData.name}
                        surveyVersion={this.props.surveyVersion}
                        allStyles={this.props.allStyles}
                        selectedUserData={this.props.selectedUserData}
                        hideDichotomies={true}
                        hideButtons={true}
                        showTraits={true}
                    />
                    
                    <FoundationsReportTeamContent style={this.props.selectedUserData.style as any} />
                    
                    <Pdf.Footer currentPage={page++} totalPages={maxPage} />
                </Pdf.Page>

                {sortedAdditionalStyles.map((styleText: StyleText) => {
                    return <Pdf.Page key={styleText.keyName}>
                        <PVAStyle
                            notificationService={this.props.notificationService}
                            history={this.props.history}
                            location={this.props.location}
                            match={this.props.match}
                            style={this.props.selectedUserData.style}
                            brief={this.props.selectedUserData.style.brief}
                            content={this.props.selectedUserData.style.content}
                            core={this.props.selectedUserData.style.core}
                            name={this.props.selectedUserData.name}
                            surveyVersion={this.props.surveyVersion}
                            allStyles={this.props.allStyles}
                            selectedUserData={this.props.selectedUserData}
                            hideDichotomies={true}
                            hideButtons={true}
                            showTraits={true}
                        />

                        {styleText.keyName && <div className={`custom-content ${styleText.keyName.toLowerCase().trim().replace(" ", "-")}-content`} style={{ '--custom-content-color': badgeColor, '--checkmark-url': checkmarkUrl, '--check-mark-url': checkMarkRedUrl } as any} key={styleText.value} dangerouslySetInnerHTML={{ __html: styleText.value}}/>}
                        
                        <Pdf.Footer currentPage={page++} totalPages={maxPage} />
                    </Pdf.Page>;
                })}
            </Pdf>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pvastyles/pdf_style.tsx